var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"d":"M61.267 31.733l50 50c.978.975.978 2.56 0 3.534a2.498 2.498 0 0 1-3.534 0L59.5 37.036 11.268 85.267A2.498 2.498 0 0 1 7 83.501c0-.64.245-1.28.733-1.769l50-50a2.498 2.498 0 0 1 3.535 0"}})}
var staticRenderFns = []

export { render, staticRenderFns }